export enum LocalStorageKey {
  DataCenterPrefix = 'dataCenterPrefix',
  DataCenterVersion = 'dataCenterVersion',
  LoginHint = 'loginHint',
  DSLanguage = 'dsLanguage',
  DSTimezone = 'dsTimezone'
}
